/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import ExecutionEnvironment from 'exenv';
import { parseBoolean } from '@tcp/core/src/utils';
import LazyLoadHOC from '@tcp/web/src/components/common/hoc/LazyLoad/LazyLoad';
import RecommendationSkeleton from '@tcp/core/src/components/common/molecules/Recommendations/views/RecommendationSkeleton.view';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import StyledModuleWrapper, { StyledModuleBLoader } from './styles';
import HomePageLoaderContext from './HomePageLoaderContext';
import Border from './Border/Border';
import {
  renderRulerEncloseBorder,
  renderSlotEncloseBorder,
  renderEnclosingBackground,
} from './EnclosingBorder.utils';
import ModuleLoader from './ModuleLoader';

const BEFORE = 'before';
const AFTER = 'after';
const ENCLOSE = 'enclose';

const isBorderWidth = (borderMedia) => {
  const configObj = borderMedia && borderMedia.config;

  return configObj && (configObj.heightD || configObj.heightT || configObj.heightM);
};

const RenderModuleLoader = ({ slot, index }) => (
  <section key={`${slot?.moduleName}-${Number(index)}`}>
    <ModuleLoader height="400" />
  </section>
);

RenderModuleLoader.propTypes = {
  slot: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const loadModuleViaIntersectionObserver = (
  index,
  ssrHomeSlotRenderCount,
  isLazyLoadHPModules,
  lazyLoadHPModulesCount
) => {
  const moduleCount = lazyLoadHPModulesCount || ssrHomeSlotRenderCount;
  return isLazyLoadHPModules && index + 1 > moduleCount;
};

const checkIfHero = (isHomePage, slot) => isHomePage && slot.isHero;

const checkIfPreload = (isHomePage, slot, index, ssrLoaderCount) =>
  isHomePage && parseBoolean(slot?.isPreload) && index + 1 <= ssrLoaderCount;

const checkIfGrouped = (isHomePage, slot) => isHomePage && parseBoolean(slot?.grp);

const checkShowLoader = (index, ssrLoaderCount) => index + 1 > ssrLoaderCount;

const checkHPPreload = (isHomePage, isPreload) => isHomePage && !isPreload;

const defaultAspectRatioObj = { aspectRatioD: '28', aspectRatioT: '38', aspectRatioM: '98' };

const spacingDefault = {
  spacingBottomA: 'medium',
  spacingBottomD: 'medium',
  spacingBottomM: 'medium',
  spacingBottomT: 'medium',
};

const enabledRouterNavigation = {
  module_container: true,
  module2columns: true,
  moduleD: true,
};

class PageSlots extends PureComponent {
  static propTypes = {
    modules: PropTypes.shape({}).isRequired,
    slots: PropTypes.arrayOf(
      PropTypes.shape({
        contentId: PropTypes.string,
        data: PropTypes.shape({}),
        moduleName: PropTypes.string,
        name: PropTypes.string,
      })
    ).isRequired,
    allModules: PropTypes.shape({}).isRequired,
  };

  constructor() {
    super();
    this.state = {
      mouseMoved: false,
      hasMounted: false,
      isShopByLookTView: false,
      isShopByLookMView: false,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    const documentBody = document.body;
    this.setState({ hasMounted: true });
    const touchHandler = () => {
      this.setState({ mouseMoved: true });
      documentBody.removeEventListener('touchstart', touchHandler);
    };
    documentBody.addEventListener('touchstart', touchHandler);

    const mouseMoveHandler = () => {
      this.setState({ mouseMoved: true });
      documentBody.removeEventListener('mousemove', mouseMoveHandler);
    };
    documentBody.addEventListener('mousemove', mouseMoveHandler);

    if (ExecutionEnvironment.canUseDOM) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }

  componentWillUnmount() {
    if (ExecutionEnvironment.canUseDOM) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  renderBorder = (slot, borderType) => {
    return (
      <>
        {slot.border &&
          slot.border
            .filter((bor) => bor.type === borderType)
            .map((bor, index) => {
              return (
                <Border
                  key={`${bor.type}_${index}`}
                  border={bor}
                  borderMedia={renderRulerEncloseBorder(slot, ENCLOSE, borderType)}
                />
              );
            })}
      </>
    );
  };

  moduleSkeletonLoader = (slot, hideOneColumn, isHpNewModuleLoader) => {
    const { data: slotData, spacing } = slot;
    const aspectRatioObj = slotData?.aspectRatioObject?.aspectRatioD
      ? slotData.aspectRatioObject
      : defaultAspectRatioObj;
    return (
      <>
        {this.renderBorder(slot, BEFORE)}
        <StyledModuleWrapper
          id={slot.name + slot.moduleName}
          spacing={spacing || spacingDefault}
          aspectRatioObject={slot.moduleName !== 'module2columns' && aspectRatioObj}
          hideOneColumn={hideOneColumn}
          isHpNewModuleLoader={isHpNewModuleLoader}
        >
          {slot.moduleName === 'module2columns' && slotData?.slot[0]?.moduleName === 'moduleB' ? (
            this.moduleBLoader(slot, slotData, hideOneColumn)
          ) : (
            <LoaderSkelton className="styled-module-loader" />
          )}
        </StyledModuleWrapper>
        {this.renderBorder(slot, AFTER)}
      </>
    );
  };

  moduleBLoader = (slot, slotData, hideOneColumn) => {
    return (
      <div className="styled-module2columns">
        {slotData?.slot.map((sd, i) => {
          const aspectRatioObjectModuleB = Object.assign({}, sd?.aspectRatioObject);
          const moduleWidthObject = sd?.set?.find((item) => item?.key === 'moduleWidth');
          const moduleWidthValue = moduleWidthObject ? moduleWidthObject.val : null;
          if (!hideOneColumn && moduleWidthValue === 'half') {
            Object.keys(aspectRatioObjectModuleB).forEach((d) => {
              if (d !== 'aspectRatioM') aspectRatioObjectModuleB[d] /= 2;
            });
          }
          return (
            ((!hideOneColumn && i === 1) || i === 0) && (
              <StyledModuleBLoader
                className={
                  i === 0
                    ? 'styled-module2columns-loader-left'
                    : 'styled-module2columns-loader-right'
                }
                aspectRatioObject={aspectRatioObjectModuleB}
                key={slot.name}
                hideOneColumn={hideOneColumn}
              >
                <LoaderSkelton className="loader-moduleN" />
              </StyledModuleBLoader>
            )
          );
        })}
      </div>
    );
  };

  hpModulesDataHandler = (homepageSlots = [], Modules = {}, isHomePage = false) => {
    return homepageSlots.map((slot) => {
      // Logic for accommodating two modules in one slot (Half width modules view)
      const { contentId: slotContent = '' } = slot;
      const contentIds = slotContent && slotContent.split(',');
      if (contentIds && contentIds.length > 1) {
        const response = {
          ...slot,
          data: {
            slot: [],
          },
        };

        if (isHomePage) {
          contentIds.forEach((contentId) => {
            response.data.slot.push(Modules[contentId]);
          });
        } else {
          response.data.slot = slot.data.slot;
        }

        return response;
      }
      // Logic ends
      return {
        ...slot,
        data: Modules[slot.contentId],
      };
    });
  };

  handleResize() {
    this.setState({
      isShopByLookMView: window.innerWidth < 768,
      isShopByLookTView: window.innerWidth < 1200,
    });
  }

  render() {
    const {
      slots = [],
      allModules,
      modules,
      isHpNewModuleDesignEnabled,
      ssrHomeSlotRenderCount,
      isLazyLoadHPModules,
      lazyLoadHPModulesCount,
      isHpNewModuleLoaderDesignEnabled,
      isBundleStaticPage,
      isStaticContentPage,
      ...others
    } = this.props;
    const ssrLoaderCount = Number(ssrHomeSlotRenderCount);
    const { mouseMoved, hasMounted, isShopByLookTView, isShopByLookMView } = this.state;
    const { isHomePage } = others;
    let isHeroSlot = false;
    let isPreload = false;
    let isGrouped = false;
    const hpSlots = this.hpModulesDataHandler(slots, allModules, isHomePage);
    const isHpNewModuleLoader =
      isHpNewModuleLoaderDesignEnabled === 'false' ? false : isHpNewModuleLoaderDesignEnabled;
    return hpSlots.map((slot, index) => {
      const key = index;
      isHeroSlot = checkIfHero(isHomePage, slot);
      isPreload = checkIfPreload(isHomePage, slot, index, ssrLoaderCount);
      isGrouped = checkIfGrouped(isHomePage, slot);
      const showOnlyLoader = !hasMounted && checkShowLoader(index, ssrLoaderCount);
      const borderMedia = renderSlotEncloseBorder(slot, ENCLOSE);
      const backgroundMedia = renderEnclosingBackground(slot);
      const { data: slotData, spacing, contentId } = slot;
      const renderModuleLoader = (hideOneColumn = false) =>
        isHpNewModuleLoader ? (
          this.moduleSkeletonLoader(slot, hideOneColumn, isHpNewModuleLoader)
        ) : (
          <RenderModuleLoader slot={slot} index={index} />
        );
      if (checkHPPreload(isHomePage, isPreload)) {
        isPreload = index === 1 || index === 2;
      }

      if (showOnlyLoader) {
        if (slot?.data?.provider?.toUpperCase() === 'ADOBE') {
          return <RecommendationSkeleton {...this.props} />;
        }
        return renderModuleLoader();
      }
      if (slot && slot.moduleName) {
        const Module = modules[slot.moduleName];
        const useRouterNavigation = enabledRouterNavigation[slot.moduleName] || false;
        const renderModule = () =>
          Module && slotData ? (
            <>
              {this.renderBorder(slot, BEFORE)}
              <StyledModuleWrapper
                id={slot.name}
                spacing={spacing || {}}
                borderMedia={borderMedia}
                backgroundMedia={backgroundMedia}
              >
                <HomePageLoaderContext.Provider value={renderModuleLoader}>
                  <Module
                    isHeroSlot={isHeroSlot}
                    isPreload={isPreload}
                    isGrouped={isGrouped}
                    key={key}
                    mouseMoved={mouseMoved}
                    slotIndex={index}
                    ssrCount={ssrLoaderCount}
                    moduleId={contentId}
                    isBorderWidth={isBorderWidth(borderMedia) || false}
                    isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
                    pageSlotName={slot.name}
                    isBundleStaticPage={isBundleStaticPage}
                    isStaticContentPage={isStaticContentPage}
                    isShopByLookTView={isShopByLookTView}
                    isShopByLookMView={isShopByLookMView}
                    {...slotData}
                    {...others}
                    useRouterNavigation={useRouterNavigation}
                  />
                </HomePageLoaderContext.Provider>
              </StyledModuleWrapper>
              {this.renderBorder(slot, AFTER)}
            </>
          ) : (
            <></>
          );
        if (
          loadModuleViaIntersectionObserver(
            index,
            ssrHomeSlotRenderCount,
            isLazyLoadHPModules,
            lazyLoadHPModulesCount
          )
        ) {
          return isHpNewModuleLoader ? (
            <LazyLoadHOC offset={1500} key={slot.contentId}>
              {(isVisible) => (isVisible ? renderModule() : renderModuleLoader())}
            </LazyLoadHOC>
          ) : (
            <LazyLoadHOC offset={1500} key={slot.contentId}>
              {(isVisible) =>
                isVisible ? renderModule() : <RenderModuleLoader slot={slot} index={index} />
              }
            </LazyLoadHOC>
          );
        }
        return renderModule();
      }
      return null;
    });
  }
}

export default PageSlots;
